import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { ToastService } from './toast-service';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ListViewGoogleCardsService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService, private toastCtrl: ToastService) { }

  getId = (): string => 'googleCards';

  getTitle = (): string => 'Google Cards';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'google-card/0', 'title': 'Styled cards', 'theme': 'layout1' },
      { 'url': 'google-card/1', 'title': 'Styled cards 2', 'theme': 'layout2' },
      { 'url': 'google-card/2', 'title': 'Styled cards 3', 'theme': 'layout3' },
      { 'url': 'google-card/3', 'title': 'Full image cards with avatar', 'theme': 'layout4' }
    ];
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'Styled cards',
      'items': [
        {
          'id': 1,
          "title": "New York Hilton Midtown",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/1.jpg",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 2,
          "title": "New York Marriott Marquis",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/2.jpg",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 3,
          "title": "Grand Hyatt New York",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/3.jpg",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 4,
          "title": "The Roosevelt Hotel",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/4.jpg",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 5,
          "title": "Kennedy Fried Chicken",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/9.jpg",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 6,
          "title": "PKorilla BBQ",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/10.jpg",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 7,
          "title": "BurritoVille",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/11.jpg",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 8,
          "title": "Mo Gridder's",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/12.jpg",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        }
      ]
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Styled cards 2',
      'items': [
        {
          'id': 1,
          'title': 'Fortuitu ad aeroportus',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                    Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image': 'assets/imgs/background/1.jpg',
          'icon': 'location'
        },
        {
          'id': 2,
          'title': 'Hoc est exortum',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                    Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image': 'assets/imgs/background/2.jpg',
          'icon': 'location'
        },
        {
          'id': 3,
          'title': 'Communications moderatoris',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                    Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image': 'assets/imgs/background/3.jpg',
          'icon': 'location'
        },
        {
          'id': 4,
          'title': 'Tabulas scripto munus agere providere',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                    Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image': 'assets/imgs/background/4.jpg',
          'icon': 'location'
        },
        {
          'id': 5,
          'title': 'In outpatient nuntiatum ministerium',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                    Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image': 'assets/imgs/background/1.jpg',
          'icon': 'location'
        }
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Styled cards 2',
      "items": [
        {
            "id": 1,
            "title": "Avenue Fouquet",
            "description": "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years",
            "image": "assets/imgs/background/1.jpg",
            "icon": "chevron-up"
        },
        {
            "id": 2,
            "title": "Rue Manon Garnier",
            "description": "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years",
            "image": "assets/imgs/background/2.jpg",
            "icon": "chevron-up"
        },
        {
            "id": 3,
            "title": "Rue de Moulin",
            "description": "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years",
            "image": "assets/imgs/background/3.jpg",
            "icon": "chevron-up"
        },
        {
            "id": 4,
            "title": "Boulevard de Lagarde",
            "description": "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years",
            "image": "assets/imgs/background/4.jpg",
            "icon": "chevron-up"
        }
      ]
    };
  }

  //* Data Set for page 4
  getDataForLayout4 = (): any => {
    return {
      'toolbarTitle': 'Full image cards with avatar',
      'items': [
        {
          'id': 1,
          'avatar': 'assets/imgs/avatar/20.jpg',
          'avatarTitle': 'Marc Ross',
          'image': 'assets/imgs/background/5.jpg',
          'title': 'Guesthouse Berlin',
          'description': `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                     Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s`
        },
        {
          'id': 2,
          'avatar': 'assets/imgs/avatar/21.jpg',
          'avatarTitle': 'Velma Powell',
          'image': 'assets/imgs/background/6.jpg',
          'title': 'Guest House Lalic',
          'description': `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                     Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s`
        },
        {
          'id': 3,
          'avatar': 'assets/imgs/avatar/23.jpg',
          'avatarTitle': 'Mindy Holmes',
          'image': 'assets/imgs/background/7.jpg',
          'title': ' Rux de Luxe City Centre',
          'description': `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                     Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s`
        },
        {
          'id': 4,
          'avatar': 'assets/imgs/avatar/24.jpg',
          'avatarTitle': 'Yvonne Robbins',
          'image': 'assets/imgs/background/8.jpg',
          'title': 'Villa Jadran Apartments ',
          'description': `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                     Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s`
        },
        {
          'id': 5,
          'avatar': 'assets/imgs/avatar/17.jpg',
          'avatarTitle': 'Caroline Stone',
          'image': 'assets/imgs/background/9.jpg',
          'title': 'Apartments Rux de Luxe',
          'description': `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                     Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s`
        }
      ]
    };
  }


  getDataForTheme = (menuItem: any): Array<any> => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  load(item: any): Observable<any> {
    const that = this;
    that.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('listView/googleCards/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            that.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            that.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        that.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
